import React, {useEffect} from 'react'
import './transhiscardde.css'

function TransHisDetailsCard({ onSelect, data, tranid }) {

    const handleAppointment = () => {
        window.location.href = `/lab/n-health/reappointment-1/${tranid}/${data.id}`;
    }

    return (
        <div 
            className="transhis-item"
            onClick={() => onSelect(data.id)}
        >
            {/* top (date & status) */}
            <div className="tsh-item-date">
                <span className={data.status === 0 ? 'left gray' : data.status === 1 ? 'left green' : 'left gray'}>{data.status === 0 ? 'รอทำนัดหมาย' : data.status === 1 ? data.strstatus :null}</span>
                <span 
                    className="right"
                >
                    <i className="bi bi-chevron-right"></i>
                </span>
            </div>
            {/* Package Name */}
            <h4 className="package-name">{data.packages_name}</h4>
            {/* text (รายการ) */}
            <p className="list">รายละเอียด</p>
            {/* details */}
            <div className="details-wrap">
                {/* item */}
                <div className="details-item">
                    <span className="left">ผู้นัดพบ</span> 
                    <span className="right">{data.Firstname} {data.Lastname}</span>
                </div>
                {/* item */}
                <div className="details-item">
                    <span className="left">สถานที่</span> 
                    <span className="right">{data.receive_service}</span>
                </div>
                {/* item */}
                <div className="details-item">
                    <span className="left">วันเวลานัด</span> 
                    <span className="right">{String(data.appointmentDate).split(" ")[0]} เวลา {String(data.appointmentDate).split(" ")[1]} น.</span>
                </div>
            </div>
            {/* Button Appointment */}
            <button 
                className="button-appoint" style={data.isAppoint === true ? {display: 'block'} : {display: 'none'}}
                onClick={data.isAppoint === true ? handleAppointment : null}
            >
                แก้ไขนัดหมาย
            </button>
        </div>

    )
}

export default TransHisDetailsCard